import React from "react";
import { Container } from "./style";
import { Toast } from "./Toast/index";
import { IToastMessages } from "../../hooks/Toast";
import { useTransition } from "react-spring";

interface IToastContainerProps {
  messages: IToastMessages[];
}

export const ToastContainer: React.FC<IToastContainerProps> = ({
  messages,
}) => {
  const messagesWithTransitions = useTransition(messages, {
    from: { right: "-120%" },
    enter: { right: "0" },
    leave: { right: "-120%" },
  });

  return (
    <Container>
      {messagesWithTransitions((style, item) => (
        <Toast toast={item} style={style} />
      ))}
    </Container>
  );
};
